import { useEffect, Component } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import { LanguageProvider } from "@/LanguageContext";
import { Nav } from "@/components/Nav";
import { Footer } from "@/components/Footer";
import { AmbientAudio } from "@/components/AmbientAudio";
import Home from "@/pages/Home";
import Accompagnements from "@/pages/Accompagnements";
import Contact from "@/pages/Contact";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  render() {
    if (this.state.error) {
      return (
        <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-obsidian px-6 text-center">
          <p className="font-serif text-3xl text-gold-light">Porte de Lumière</p>
          <p className="text-sm text-white/60">Une erreur est survenue. Rechargez la page pour continuer.</p>
        </div>
      );
    }
    return this.props.children;
  }
}

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

const PageRoutes = () => (
  <>
    <ScrollToTop />
    <Nav />
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/accompagnements" element={<Accompagnements />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="*" element={<Home />} />
    </Routes>
    <Footer />
    <AmbientAudio />
  </>
);

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <ErrorBoundary>
      <LanguageProvider>
        <div className="grain min-h-screen bg-obsidian text-white">
          <BrowserRouter>
            <PageRoutes />
          </BrowserRouter>
          <Toaster position="bottom-center" theme="dark" toastOptions={{ style: { background: "#101622", border: "1px solid rgba(212,175,55,0.3)", color: "#F8FAFC" } }} />
        </div>
      </LanguageProvider>
    </ErrorBoundary>
  );
}

export default App;
